import React from 'react';
import { BookOpenIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';
const assurances = [{
  label: 'Instant Digital Access',
  Icon: ZapIcon
}, {
  label: 'Secure Checkout',
  Icon: LockIcon
}, {
  label: 'Ready-to-Use Teaching Resources',
  Icon: BookOpenIcon
}];
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-charcoal px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-90" data-mp="ivb7x70ful2p">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="eur6vscquxba">
        <h2 id="final-heading" className="mx-auto font-display text-[2.6rem] font-bold leading-[1.04] text-brand-ivory sm:text-[3.4rem]" data-id="element-92" data-mp="ew2btvhxeb3z">
          Your Next Class Doesn’t Have to <em className="italic text-brand-butter" data-id="element-93" data-mp="nsl1myuv1iwc">Start From Zero.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-ivory sm:text-[17px]" data-id="element-94" data-mp="2ulngf08bdyew">
          You already know how to teach.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-95" data-mp="2qiubw093gk8y">
          Now give yourself a system that helps you prepare faster, explain more clearly and walk into
          class with structure.
        </p>

        <img src={MOCKUP_URL} alt="The complete Cosmetology Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.45))'
      }} data-id="element-96" data-mp="34964e09lcl0m" />

        <p className="mt-8 font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-butter" data-id="element-97" data-mp="3j789iew9tejz">
          Cosmetology Instructor Ready™
        </p>
        <p className="mx-auto mt-3 max-w-xl font-display text-[1.5rem] font-bold leading-snug text-brand-ivory sm:text-[1.8rem]" data-id="element-98" data-mp="1ot7ey67r7dpp">
          6 Volumes. 5 Bonuses. One complete skin-first teaching system.
        </p>

        <CtaBlock label="Get My Teaching System Now" tone="dark" className="mt-10" data-id="element-99" data-mp="2w5pwv8zicxn7" />

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-100" data-mp="2r6vgsesxdn6s">
          {assurances.map(({
          label,
          Icon
        }) => <li key={label} className="flex items-center gap-1.5 font-body text-[12px] text-brand-ivory/70" data-id="element-101" data-mp="353idcggyubc6">
              <Icon className="h-3.5 w-3.5 text-brand-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-102" data-mp="316dzkrx3n2x9" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}